var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.695 0 4.275 4.275L4.407 16.837l-.579.04-.537.034-.947.044-.41.01-.368.005-.325-.004-.283-.01-.241-.018-.199-.025c-.177-.029-.291-.069-.342-.12-.05-.05-.09-.164-.119-.341l-.025-.199-.018-.24-.01-.284L0 15.404l.004-.368.011-.41.044-.947.033-.537.04-.58L12.695 0zM9.806 5.738l-8.249 8.25.015 1.41 1.41.014 8.249-8.249-1.425-1.425zm2.918-2.917-1.697 1.696 1.425 1.425 1.697-1.696-1.425-1.425z",
    fill: "#484848",
    fillRule: "nonzero"
  })));
};

export default SvgPencil;